// Chat component types and constants
export const STATUS = {
  ONLINE: 'online',
  BUSY: 'busy',
  AWAY: 'away',
  OFFLINE: 'offline'
};

export const CHAT_STATUS = {
  UNRESOLVED: 'unresolved',
  RESOLVED: 'resolved',
  FORWARDED: 'forwarded'
};

export const MESSAGE_ROLES = {
  USER: 'user',
  ASSISTANT: 'assistant'
};

export const ACTIVE_TABS = {
  ALL: 'All',
  INBOX: 'Inbox',
  MY: 'My',
  ALERTS: 'Alerts',
  PIN_CHAT: 'Pinned'
};

export const MESSAGE_ACTIONS = {
  REPLY: 'reply',
  EDIT: 'edit',
  COPY: 'copy',
  REACT: 'react',
  FORWARD: 'forward',
  PIN: 'pin',
  STAR: 'star',
  DELETE: 'delete',
  MARK_AS_QUESTION: 'mark_as_question',
  MARK_AS_ANSWER: 'mark_as_answer',
  MARK_AS_FOLLOW_UP: 'mark_as_follow_up'
};

export const FORMATTING_TYPES = {
  BOLD: 'bold',
  ITALIC: 'italic'
};

export const FILE_TYPES = {
  IMAGE: 'image/*',
  VIDEO: 'video/*',
  PDF: '.pdf',
  DOC: '.doc',
  DOCX: '.docx',
  XLSX: '.xlsx',
  PPTX: '.pptx',
  TXT: '.txt'
};

/** Image extensions browsers often report with empty or generic MIME types */
export const IMAGE_EXTENSION_FALLBACKS = ['.heic', '.heif'];

export const MIME_BY_EXTENSION = {
  '.heic': 'image/heic',
  '.heif': 'image/heif',
  '.pdf': 'application/pdf',
  '.doc': 'application/msword',
  '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  '.txt': 'text/plain',
};

export const getFileAcceptAttribute = () => [
  ...Object.values(FILE_TYPES),
  ...IMAGE_EXTENSION_FALLBACKS,
].join(',');

export const MEDIA_KINDS = {
  IMAGE: 'image',
  VIDEO: 'video',
  AUDIO: 'audio',
  VOICE: 'voice',
  DOCUMENT: 'document',
  STICKER: 'sticker',
  LOCATION: 'location',
  CONTACT: 'contact'
};

export const SENDER_TYPES = {
  CUSTOMER: 'Customer',
  AGENT: 'Agent',
  BOT: 'Bot'
};

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const MAX_ATTACHMENTS = 30; // Maximum number of attachments per message

/**
 * Formats the FILE_TYPES constant into a user-friendly string
 * @returns {string} Formatted string like "Images, Videos, PDF, DOC, DOCX, TXT"
 */
export const getFormattedFileTypes = () => {
  const types = [];
  const imageExtras = IMAGE_EXTENSION_FALLBACKS
    .map((ext) => ext.substring(1).toUpperCase())
    .join('/');

  Object.values(FILE_TYPES).forEach((type) => {
    if (type === 'image/*') {
      types.push(imageExtras ? `Images (${imageExtras})` : 'Images');
    } else if (type === 'video/*') {
      types.push('Videos');
    } else if (type.startsWith('.')) {
      types.push(type.substring(1).toUpperCase());
    }
  });

  return types.join(', ');
};
